export const ProfessionalServiceIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.5191 28.5625L32.4358 23.5208C32.6233 23.2083 32.5399 22.8125 32.2691 22.5833L29.1858 20.1666C29.2483 19.7083 29.2899 19.2291 29.2899 18.75C29.2899 18.2708 29.2483 17.7916 29.1858 17.3125L32.2691 14.8958C32.5399 14.6666 32.6233 14.2708 32.4358 13.9583L29.5191 8.91663C29.3316 8.60413 28.9566 8.47913 28.6233 8.60413L24.9983 10.0625C24.2483 9.47913 23.4358 8.99996 22.5399 8.62496L21.9983 4.77079C21.9633 4.6023 21.8721 4.4507 21.7396 4.34091C21.6071 4.23112 21.4411 4.16966 21.2691 4.16663H15.4358C15.0816 4.16663 14.7691 4.43746 14.7066 4.79163L14.1649 8.64579C13.2899 9.02079 12.4566 9.49996 11.7066 10.0833L8.08159 8.62496C7.74826 8.49996 7.37326 8.62496 7.18576 8.93746L4.26909 13.9791C4.08159 14.2916 4.16492 14.6875 4.43576 14.9166L7.51909 17.3333C7.45659 17.7916 7.41492 18.2708 7.41492 18.75C7.41492 19.2291 7.45659 19.7083 7.51909 20.1875L4.43576 22.6041C4.16492 22.8333 4.08159 23.2291 4.26909 23.5416L7.18576 28.5833C7.37326 28.8958 7.74826 29.0208 8.08159 28.8958L11.7066 27.4375C12.4566 28.0208 13.2691 28.5 14.1649 28.875L14.7066 32.7291C14.7691 33.0625 15.0816 33.3333 15.4358 33.3333H21.2691C21.6233 33.3333 21.9358 33.0625 21.9983 32.7083L22.5399 28.8541C23.4149 28.4791 24.2483 28 24.9983 27.4166L28.6233 28.875C28.9566 29 29.3316 28.875 29.5191 28.5625ZM18.3524 22.9166C16.0608 22.9166 14.1858 21.0416 14.1858 18.75C14.1858 16.4583 16.0608 14.5833 18.3524 14.5833C20.6441 14.5833 22.5191 16.4583 22.5191 18.75C22.5191 21.0416 20.6441 22.9166 18.3524 22.9166ZM45.6649 38.8958L43.6649 37.3541C43.7066 37.0625 43.7483 36.75 43.7483 36.4375C43.7483 36.125 43.7274 35.8125 43.6649 35.5208L45.6441 33.9791C45.8108 33.8333 45.8733 33.5833 45.7483 33.375L43.8733 30.1458C43.7691 29.9375 43.5191 29.875 43.2899 29.9375L40.9774 30.875C40.4983 30.5 39.9774 30.1875 39.3941 29.9583L39.0399 27.5C39.0317 27.3886 38.9823 27.2843 38.9015 27.2073C38.8206 27.1303 38.714 27.0861 38.6024 27.0833H34.8733C34.6441 27.0833 34.4358 27.25 34.4149 27.4791L34.0608 29.9375C33.4983 30.1875 32.9566 30.4791 32.4774 30.8541L30.1649 29.9166C30.0588 29.8767 29.9419 29.8757 29.8351 29.9139C29.7283 29.952 29.6384 30.0268 29.5816 30.125L27.7066 33.3541C27.6024 33.5625 27.6233 33.8125 27.8108 33.9583L29.7899 35.5C29.704 36.1081 29.704 36.7252 29.7899 37.3333L27.8108 38.875C27.6441 39.0208 27.5816 39.2708 27.7066 39.4791L29.5816 42.7083C29.6858 42.9166 29.9358 42.9791 30.1649 42.9166L32.4774 41.9791C32.9566 42.3541 33.4774 42.6666 34.0608 42.8958L34.4149 45.3541C34.4566 45.5833 34.6441 45.75 34.8733 45.75H38.6024C38.8316 45.75 39.0399 45.5833 39.0608 45.3541L39.4149 42.8958C39.9774 42.6458 40.5191 42.3541 40.9774 41.9791L43.3108 42.9166C43.5191 43 43.7691 42.9166 43.8941 42.7083L45.7691 39.4791C45.8941 39.2916 45.8316 39.0416 45.6649 38.8958ZM36.7274 39.2291C36.3579 39.229 35.9921 39.1561 35.6508 39.0146C35.3095 38.873 34.9994 38.6657 34.7383 38.4043C34.4771 38.143 34.27 37.8327 34.1287 37.4913C33.9874 37.1499 33.9148 36.784 33.9149 36.4145C33.9151 36.0451 33.988 35.6792 34.1295 35.3379C34.271 34.9966 34.4784 34.6865 34.7397 34.4254C35.0011 34.1642 35.3113 33.9571 35.6527 33.8158C35.9941 33.6745 36.36 33.6019 36.7295 33.602C37.4757 33.6023 38.1912 33.899 38.7187 34.4268C39.2461 34.9547 39.5423 35.6704 39.542 36.4166C39.5417 37.1628 39.245 37.8783 38.7172 38.4058C38.1894 38.9332 37.4736 39.2294 36.7274 39.2291Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
export const UtilityIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1063_44333)">
          <path
            d="M8.83218 14.8073L5.09184 8.57337L7.5854 6.0798L13.8193 9.82015V12.3137L20.2313 18.7257C20.2313 18.9038 20.2313 19.082 20.2313 19.2601L17.9159 21.3974L11.3257 14.8073H8.83218ZM35.5489 29.9468C35.0146 29.9468 34.6584 29.9468 34.1241 29.9468C32.8773 29.9468 31.8086 29.7687 30.7399 29.5906L26.9996 33.8652L35.3708 43.3052C37.3301 45.4425 40.7142 45.6206 42.6734 43.4833C44.8108 41.3459 44.6326 38.1399 42.4953 36.1807L35.5489 29.9468ZM41.6047 23.1785C44.4545 20.3287 45.3451 16.0541 44.2764 12.3137C44.0983 11.6013 43.2078 11.4232 42.8515 11.9575L36.6176 18.1914L31.6305 13.2043L37.8644 6.97036C38.3987 6.43603 38.2206 5.72358 37.5082 5.54547C33.7678 4.29869 29.4931 5.18924 26.6434 8.21714C23.4373 11.4232 22.7249 16.4103 24.506 20.3287L6.69484 36.1807C4.5575 38.1399 4.37939 41.524 6.51673 43.4833C8.65407 45.6206 11.8601 45.4425 13.8193 43.3052L29.6713 25.494C33.5897 27.2751 38.3987 26.5627 41.6047 23.1785Z"
            fill="#00A0FC"
          />
        </g>
        <defs>
          <clipPath id="clip0_1063_44333">
            <rect width="50" height="50" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const CollectionIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.9987 4.16663C23.957 4.16663 22.9154 4.56246 22.0612 5.39579L15.1862 12.25L24.9987 22.0416L34.8112 12.25L27.9362 5.39579C27.082 4.56246 26.0404 4.16663 24.9987 4.16663ZM12.2487 15.1875L5.39453 22.0625C3.7487 23.6875 3.7487 26.3125 5.39453 27.9375L12.2487 34.8125L22.0404 25L12.2487 15.1875ZM37.7487 15.1875L27.957 25L37.7487 34.8125L44.6029 27.9375C46.2487 26.3125 46.2487 23.6875 44.6029 22.0625L37.7487 15.1875ZM24.9987 27.9583L15.1862 37.75L22.0612 44.6041C23.6862 46.25 26.3112 46.25 27.9362 44.6041L34.8112 37.75L24.9987 27.9583Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
export const InsuranceIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.3511 5.79446C28.726 7.35196 31.2867 8.60553 33.9734 9.52584C35.967 10.2193 38.0799 10.5039 40.1859 10.3626L42.3707 10.164L42.4781 12.3586C42.8786 20.4302 41.5762 27.4436 38.8444 32.9756C36.0019 38.7322 31.6324 42.8901 26.0223 45H24.5636C19.0805 42.9976 14.7435 38.9536 11.8652 33.1254C9.17898 27.6553 7.80169 20.5897 8.02309 12.1632L8.0817 9.99797L10.2339 10.1087C12.5768 10.2607 14.9286 10.0197 17.192 9.3956C19.642 8.67994 21.9298 7.49566 23.9287 5.90842L25.0976 5L26.3511 5.79446ZM25.2343 11.2841C29.6397 14.0777 33.6185 15.3997 37.0341 15.0936C37.6299 27.1408 33.1757 36.3488 25.2799 39.3215C17.6511 36.5376 13.1415 27.6488 13.4769 14.9015C17.485 15.1131 21.4215 14.2503 25.2343 11.2841ZM22.8184 25.0602C23.1223 25.3195 23.4094 25.598 23.678 25.8938C24.4897 24.585 25.3893 23.3329 26.3707 22.1461C29.0536 18.9064 28.2526 19.118 31.9743 19.118L31.4435 19.6911C30.0463 21.2584 28.7623 22.9232 27.6014 24.6728C26.3109 26.539 25.1407 28.4857 24.098 30.501L23.7724 31.1229L23.4761 30.4912C22.9498 29.3425 22.2838 28.2632 21.4932 27.2776C20.7798 26.3763 19.9281 25.5939 18.9698 24.9593C19.4549 23.3671 21.7667 24.1844 22.8021 25.0602H22.8184ZM25.2213 7.5755C30.8802 11.1571 35.9889 12.8567 40.378 12.4595C41.1432 27.9548 35.4191 39.2141 25.2799 43.0334C15.4891 39.455 9.69668 28.5897 10.1265 12.2218C15.2742 12.4888 20.3275 11.3785 25.2213 7.5755Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
export const EcommerceIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3665 9.10156H42.7376C44.7233 9.10156 44.6159 9.9056 44.4434 11.9564L43.3138 26.3574C43.1217 28.6523 43.2845 28.0957 40.8529 28.444L18.5156 31.2858L19.6973 34.7135C29.388 34.7135 34.0723 34.7135 43.7565 34.7135C44.082 35.931 44.5247 37.9134 44.8503 39.2708H40.8529L40.4687 37.8841C32.3958 37.8841 29.3197 37.8841 21.2435 37.8841C16.8327 37.8092 17.2754 39.0039 16.2174 35.1921L8.63932 7.63997H5V5H11.3835C11.6797 6.11003 12.0898 7.97852 12.3665 9.10156ZM22.4772 38.8281C24.1797 38.8281 25.5631 40.2116 25.5631 41.9141C25.5631 43.6198 24.1797 45 22.4772 45C20.7715 45 19.3913 43.6198 19.3913 41.9141C19.3913 40.2116 20.7715 38.8281 22.4772 38.8281ZM35.2051 38.8281C36.9076 38.8281 38.291 40.2116 38.291 41.9141C38.291 43.6198 36.9076 45 35.2051 45C33.4993 45 32.1191 43.6198 32.1191 41.9141C32.1191 40.2116 33.5026 38.8281 35.2051 38.8281Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
export const NonProfitIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1063_44344)">
          <path
            d="M7.83594 23.9477C7.83594 22.1345 9.3106 20.6598 11.1233 20.6598C12.9365 20.6598 14.4112 22.1345 14.4112 23.9477C14.4112 25.7604 12.9365 27.235 11.1233 27.235C9.3106 27.235 7.83594 25.7604 7.83594 23.9477Z"
            fill="#00A0FC"
          />
          <path
            d="M30.1982 16.2736C30.6228 13.6578 28.8464 11.1932 26.2306 10.7687C23.6149 10.3441 21.1502 12.1205 20.7257 14.7363C20.3012 17.352 22.0775 19.8167 24.6933 20.2412C27.3091 20.6657 29.7737 18.8894 30.1982 16.2736Z"
            fill="#00A0FC"
          />
          <path
            d="M36.5039 23.9477C36.5039 22.1345 37.9786 20.6598 39.7912 20.6598C41.6045 20.6598 43.0791 22.1345 43.0791 23.9477C43.0791 25.7604 41.6045 27.235 39.7912 27.235C37.9786 27.235 36.5039 25.7604 36.5039 23.9477Z"
            fill="#00A0FC"
          />
          <path
            d="M48.5999 26.2719L44.2465 32.1767C43.8429 32.7239 43.6293 33.3728 43.6293 34.0533V38.7C43.6293 39.4167 43.046 40 42.3293 40H37.166C36.4493 40 35.8665 39.4167 35.8665 38.7V34.055C35.8665 33.375 35.6529 32.7256 35.2493 32.1779L31.1938 26.676L31.0322 26.8953C30.5252 27.5832 30.246 28.4321 30.246 29.2856V38.4445C30.246 39.3019 29.5479 40 28.6899 40H22.2294C21.3714 40 20.6739 39.3019 20.6739 38.4445V29.2873C20.6739 28.4333 20.3947 27.5843 19.8883 26.897L19.7255 26.676L15.6706 32.1767C15.2727 32.7171 15.0534 33.3829 15.0534 34.0533V38.7C15.0534 39.4167 14.4701 40 13.7539 40H8.59061C7.87335 40 7.29004 39.4167 7.29004 38.7V34.055C7.29004 33.375 7.07695 32.7256 6.67338 32.1779L2.31948 26.2719C1.78252 25.5427 1.93852 24.5129 2.66652 23.9754C2.95083 23.7662 3.2877 23.6555 3.6404 23.6555C4.1604 23.6555 4.65497 23.9047 4.96302 24.323L6.64456 26.6042C7.69983 28.0359 9.3921 28.8905 11.1714 28.8905C12.0481 28.8905 12.9247 28.682 13.707 28.2869C14.4887 27.8918 15.1771 27.3102 15.6977 26.6042L17.3804 24.3224C17.4799 24.1879 17.5986 24.0698 17.7319 23.972L14.4401 19.5062C13.7912 18.6261 13.9794 17.3821 14.8595 16.7332C15.2037 16.4794 15.6101 16.346 16.0357 16.346C16.6642 16.346 17.2617 16.6473 17.6336 17.152L19.7379 20.0069C21.0718 21.8162 23.2106 22.8969 25.4591 22.8969C26.5669 22.8969 27.6753 22.633 28.6639 22.1333C29.6525 21.6342 30.5229 20.8989 31.1808 20.0069L33.2852 17.152C33.6 16.7258 34.0612 16.4472 34.5852 16.368C35.1091 16.2884 35.6325 16.4184 36.0587 16.7326L36.0768 16.7462C36.4934 17.0599 36.7652 17.516 36.8438 18.0326C36.9229 18.5566 36.7935 19.08 36.4792 19.5067H36.4787L33.1863 23.9725C33.3202 24.0703 33.4395 24.1885 33.5384 24.323L35.2205 26.6042C36.2758 28.0359 37.968 28.8905 39.7473 28.8905C40.624 28.8905 41.5007 28.682 42.2829 28.2869C43.0652 27.8912 43.7536 27.3096 44.2736 26.6042L45.9563 24.3224C46.2163 23.9697 46.5978 23.7391 47.0319 23.6735C47.4332 23.6125 47.8345 23.7007 48.172 23.9205H48.1765L48.2522 23.9754C48.6055 24.2359 48.8361 24.618 48.9017 25.0516C48.9672 25.4856 48.8599 25.9186 48.5999 26.2719Z"
            fill="#00A0FC"
          />
        </g>
        <defs>
          <clipPath id="clip0_1063_44344">
            <rect width="50" height="50" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const TickMarkIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="13" cy="13" r="13" fill="#EDF8FF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 12.7486C8.13844 12.7079 8.78125 12.5895 10.9934 15.2422C12.69 12.4886 14.5753 10.1051 16.6159 8.02576C18.625 5.97793 18.6406 5.97273 21 6.00731C16.9856 10.3753 13.7097 15.0486 11.0897 20C9.6875 17.0591 7.72906 14.5832 5 12.7486Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};



